// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "container-21-Gz";
var _4 = "name-3Yp2u";
var _5 = "iata-3oIyI";
var _6 = "loader-22NEA";
var _7 = "colorPrimary-wOQF4";
var _8 = "placeholder-zXme-";
export { _1 as "__esModule", _2 as "mobile", _3 as "container", _4 as "name", _5 as "iata", _6 as "loader", _7 as "colorPrimary", _8 as "placeholder" }
export default { "__esModule": _1, "mobile": _2, "container": _3, "name": _4, "iata": _5, "loader": _6, "colorPrimary": _7, "placeholder": _8 }
